import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import domainService from '../../../services/domainService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';

const DeleteDomainEmail = ({ onClose, emailId, singleIdentity }) => {
  const navigate = useNavigate();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  async function handleDeleteDoaminEmail() {
    try {
      setLoading(true);
      let res;
      if (singleIdentity) {
        res = await domainService.deleteSigleIdentityEmail(emailId);
      } else {
        res = await domainService.deleteDomainEmail(emailId);
      }
      if (res?.success) {
        setConfirmDelete(true);
      }
    } catch (err) {
      Toast({ type: 'error', message: err?.mesage });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Email Account!"
          description="Are you sure you want to delete this email account? This action cannot be undone. Once this account is deleted, all running campaigns will no longer be able to send emails using this email address."
          btns={
            <>
              <Button onClick={() => onClose()}>Cancel</Button>
              <Button variant="danger" onClick={() => handleDeleteDoaminEmail()} loader={loading} disabled={loading}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Email Account Deleted Successfully!"
          btns={
            <Button
              onClick={() => {
                onClose();
                refetch();
              }}>
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DeleteDomainEmail;
